import { SessionGetInterface } from "@components/EditionFormCst/types";
import SessionAccordionCst from "@components/SessionAccordionCst";
import { Box, Grid, Typography, useTheme } from "@mui/material";
import dayjs from "dayjs";
import React from "react";
import { useTranslation } from "react-i18next";
import { ColumnsType } from "src/interfaces/Common";

type PROPS = {
  list: SessionGetInterface[];
  isVirtual?: boolean;
};

const DetailSessions: React.FC<PROPS> = ({ list, isVirtual }) => {
  const { t } = useTranslation(["teachers-area-detail-page"]);
  const theme = useTheme();

  return (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          position: "relative",
        }}
      >
        <Typography
          variant="subtitle2"
          sx={{
            margin: "15px 0px",
            borderBottom: `1px solid ${theme.palette.primary.main}`,
          }}
        >
          {t(`session-detail.hero-title`)}
        </Typography>
      </Box>
      {list?.map((session: SessionGetInterface, index: number) => (
        <SessionAccordionCst
          isDetail={true}
          data={session}
          index={index}
          isVirtual={isVirtual}
        />
      ))}
    </>
  );
};

export default DetailSessions;
